import { useState, useContext } from 'react';
import { Form, Spinner, Image } from 'react-bootstrap';
import logorect from '../img/logorect.png';
import axios from "axios";
import { AppContext } from '../App';


export const Authentication = () => {
	const { authForm, setAuthForm, setAccessToken, link, setUser } = useContext(AppContext);

	const [loginError, setLoginError] = useState(false);
	const [load, setLoad] = useState(false);
	const getUser = (token) => {
		axios.get(`${link}api/pnp/get/user/`, {
			headers: {
				Authorization: 'Bearer ' + token
			}
		}).then(response => {
			setUser(response.data);
		}).catch(err => {
			setAuthForm(true);
			if (err.response.status === 401) {
				setAuthForm(true);
			} else if (err.response.status === 404) {
				console.log('Get_user - ', err.response.status, ':', err.response.statusText);
			} else if (err.response.status === 500) {
				console.log('Get_user - ', err.response.status, ':', err.response.statusText);
			} else {
				console.log('Get_user - ', err.response.status, ':', err.response.data);
			}
		});
	}
	const requestUser = (event) => {
		setLoad(true);
		event.preventDefault();
		if (event.target.username.value !== "" && event.target.password.value !== "") {
			axios.post(`${link}api/token/`, {
				username: event.target.username.value,
				password: event.target.password.value,
			}).then(function (response) {
				setLoad(false);
				if (response.status === 200) {
					setAccessToken(response.data.access);
					getUser(response.data.access);
					setAuthForm(false);
				} else {
					setLoginError(true);
					setTimeout(() => { setLoginError(false) }, 5000);
				}
			}).catch(function (err) {
				setLoad(false);
				setLoginError(true);
				setTimeout(() => { setLoginError(false) }, 5000);
			});
		}
	}


	return (
		<div className="auth-page-wrapper">
			<div className="auth-background-overlay"></div>
			<div className="auth-content-container">
				<div className="auth-card">
					<div className="auth-card-header">
						<div className="auth-logo-container">
							<div className="auth-logo-icon">
								<i className="bi bi-shield-lock-fill"></i>
							</div>
							<div className='d-flex justify-content-center align-items-center mb-2' >
								<div className='auth-logo-wrapper bg-white px-4 pt-2 br-4'>
									<Image src={logorect} style={{ width: '150px' }} />
								</div>
							</div>
							<h1 className="auth-title">Welcome Back</h1>
							<p className="auth-subtitle">Sign in to continue to your account</p>
						</div>
					</div>

					<div className="auth-card-body">
						{loginError && (
							<div className="auth-error-alert">
								<i className="bi bi-exclamation-circle-fill"></i>
								<span>Invalid credentials! Please try again.</span>
							</div>
						)}

						{authForm ? (
							<Form onSubmit={requestUser} className="auth-form">
								<div className="auth-form-group">
									<div className="auth-input-wrapper">
										<i className="bi bi-person-fill auth-input-icon"></i>
										<Form.Control
											type="text"
											name="username"
											required
											className="auth-input"
											placeholder=" "
											autoComplete="username"
										/>
										<label className="auth-floating-label">Username</label>
									</div>
								</div>

								<div className="auth-form-group">
									<div className="auth-input-wrapper">
										<i className="bi bi-lock-fill auth-input-icon"></i>
										<Form.Control
											type="password"
											name="password"
											required
											className="auth-input"
											placeholder=" "
											autoComplete="current-password"
										/>
										<label className="auth-floating-label">Password</label>
									</div>
								</div>

								<div className="auth-form-actions">
									{load ? (
										<button type="button" className="auth-submit-btn auth-submit-btn-loading" disabled>
											<Spinner animation="border" size="sm" className="auth-spinner" />
											<span>Signing in...</span>
										</button>
									) : (
										<button type="submit" className="auth-submit-btn">
											<span>Sign In</span>
											<i className="bi bi-arrow-right-circle-fill"></i>
										</button>
									)}
								</div>
							</Form>
						) : (
							<div className="auth-loading-state">
								<Spinner animation="border" className="auth-loading-spinner" />
								<p>Fetching your information...</p>
							</div>
						)}
					</div>

					<div className="auth-card-footer">
						<div className="auth-footer-decoration"></div>
					</div>
				</div>
			</div>
		</div>
	);
}